import styled from '@emotion/styled';
import { NextPage } from 'next';
// import dynamic from 'next/dynamic';
// import { NextRouter, useRouter } from 'next/router';
import { memo } from 'react';
import { DEFAULT_COUNT_VIEW } from 'src/constants';
import { IArticle } from 'src/interface/section';
// import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
// import useResponsive from 'src/utils/devices';
import { useDateUpdateDataLayer } from 'src/utils/helper';
import { Viewer } from '../cards';
// const WidgetSocial = dynamic(import('src/components/widget/widget-social-share'));

type Props = {
  data: IArticle;
  showWidgetSocial?: boolean;
  showDate?: boolean;
  showViewer?: boolean;
  showGallery?: boolean;
  countView?: any;
  isTranslate?: any;
};

// showWidgetSocial = true,
// showGallery = true,

const WidgetMetaContent: NextPage<Props> = ({ data, showDate = true, showViewer = true, countView, isTranslate }) => {
  // const router: NextRouter = useRouter();
  // const responsive = useResponsive();
  const conditionCountview: boolean = showViewer && countView > DEFAULT_COUNT_VIEW;

  const publishedAt = new Date(data.published_at ?? '');
  const updatedAt = new Date(data.updated_at ?? '');

  // Check if updated_at is greater than published_at
  const isUpdatedAfterPublished = updatedAt > publishedAt;
  return (
    <WidgetWrapper className='widget-meta-content'>
      <div className='meta'>
        {/* {showWidgetSocial && (
          <WidgetSocial
            articleLink={`${router.asPath}`}
            // ! DATALAYER
            title={isTranslate ? 'Share' : 'แชร์'}
            eventDataLayer={{
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              position: responsive.isMobile ? (showGallery ? 'ใต้:อัลบั้มรูป' : 'ใต้:หัวข้อข่าว') : 'ใต้:หัวข้อข่าว',
              section: 'แชร์'
            }}
          />
        )} */}
        {data.byline && (
          <div className='byline'>
            {/* <AiOutlineUser /> */}
            {data.byline}
          </div>
        )}
      </div>
      <div className='meta'>
        {showDate && data.published_at && (
          <div className='date-publish'>
            <div className='date'>
              {/* <BiTimeFive size={14} /> */}
              {`${useDateUpdateDataLayer(data.published_at, true, isTranslate)}`}
            </div>
          </div>
        )}
        <div className='flex-end'>
          {(showDate && isUpdatedAfterPublished) && data.updated_at && (
            <div className='date-update'>
              {/* <BiTimeFive size={14} /> */}
              <span>
                อัปเดตล่าสุด :
              </span>
              {`${useDateUpdateDataLayer(data.updated_at, true, isTranslate)}`}
            </div>
          )}
          {conditionCountview && <Viewer data={countView} />}
        </div>
      </div>
    </WidgetWrapper>
  );
};
const WidgetWrapper = styled.div`
  position: relative;
  width: 100%;
  display: block;
  padding-bottom: 15px;
  @media (max-width: 690px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    svg {
      width: 12px;
      height: 12px;
    }
  }
  .meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    width: 100%;
    @media (max-width: 767px) {
      margin-top: 10px;
      padding-bottom: 0px;
    }
    .byline {
      color: #e67e23;
      font-weight: 600;
      display: flex;
      align-items: center;
      margin: 0;
      font-size: 20px;
    }
    .flex-end {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      @media (max-width: 690px) {
        width: 160%;
       
        .viewer {
          display: none;
        }
      }
    }
    .date-update {
      font-size: 14px;
      color: #424242;
      span {
        font-size: 15px;
        padding-right: 5px;
      }
      @media (max-width: 690px) {
        font-size: 12px;
        span {
          font-size: 13px;
        }
      }
    }
    .date-publish,
    .viewer {
      font-weight: 400;
      color: #424242;
      width: 100%;
      display: flex;
      align-items: center;
    }
    .date-publish {
      justify-content: flex-start;
      svg {
        margin-right: 5px;
        margin-top: 5px;
      }
    }
    .flex-end .date-publish {
      justify-content: flex-start !important;

    }
    .viewer {
      width: auto;
      justify-content: flex-end;
    }

    .date-publish,
    svg,
    .viewer span {
      font-size: 16px;
      margin-right: 5px;
      @media (max-width: 690px) {
        font-size: 12px;
      }
    }
  }

  margin: 15px auto 0;
  @media (max-width: 767px) {

    .widget-social-share {
      .title {
        text-align: end;
        margin: 10px 5px 5px 0;
        padding: 0;
      }
      .list-items {
        display: flex;
        justify-content: space-between;
        align-items: center;
        svg {
          vertical-align: middle;
          height: 30px;
          width: 30px;
          color: #fff;
        }
      }
    }
  }
`;
export default memo(WidgetMetaContent);
